import { apiClient } from '../http/client'

export const projectApi = {
  bindProject: async (projectId: string) => {
    const response = await apiClient.post('/projects/bind', {
      project_id: projectId,
    })
    return response.data as {
      success: boolean
      user_id: string
      project_id: string
    }
  },
  listMine: async () => {
    const response = await apiClient.get('/projects/mine')
    return response.data as {
      project_ids: string[]
    }
  },
  usage: async (projectId?: string) => {
    const response = await apiClient.get('/projects/usage', {
      params: {
        project_id: projectId || undefined,
      },
    })
    return response.data as {
      user_id: string
      project_id: string | null
      day_start_utc: string
      daily_message_limit: number
      daily_message_used: number
      daily_message_remaining: number | null
      daily_project_message_limit: number
      daily_project_message_used: number | null
      daily_project_message_remaining: number | null
    }
  },
}
